import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import { $gitRemotes } from "../../internal/git";

/**
 * Hook to access git remotes
 * @param documentId - The document ID
 * @returns List of remotes
 */
export const useGitRemotes = (documentId: string | undefined) => {
	const remotesAtom = $gitRemotes(documentId);
	const remotesLoadable = useAtomValue(loadable(remotesAtom));
	const refresh = useSetAtom(remotesAtom);

	return {
		remotes: remotesLoadable.state === "hasData" ? remotesLoadable.data : [],
		refresh,
		isLoading: remotesLoadable.state === "loading",
		isError: remotesLoadable.state === "hasError",
	};
};
